export class TextToSpeechWeb {
  constructor() {
    this.synth = window.speechSynthesis;
    this.utterance = null;
    this.isSpeaking = false;
  }

  speak(text, onEndCallback, onBoundaryCallback) {
    if (this.isSpeaking) {
      this.stop(); // Stop any ongoing speech first
    }
    
    // Create fresh utterance to avoid recycled event handlers
    this.utterance = new SpeechSynthesisUtterance(text);
    
    // Add error handling
    this.utterance.onerror = (event) => {
      console.error('Speech error:', event.error);
      this.stop();
      if (onEndCallback) onEndCallback(event);
    };

    // Boundary callback
    if (onBoundaryCallback) {
      this.utterance.onboundary = onBoundaryCallback;
    }

    // End callback
    this.utterance.onend = () => {
      this.isSpeaking = false;
      if (onEndCallback) onEndCallback();
    };

    this.synth.speak(this.utterance);
    this.isSpeaking = true;
  }

  stop() {
    if (this.isSpeaking) {
      this.synth.cancel();
      this.isSpeaking = false;
    }
  }
}